export const ProviderTypes = {
  medical: 'medical',
  therapyNow: 'therapy-now',
  therapyScheduled: 'therapy-scheduled',
  therapyAll: 'therapy-all',
  psychiatry: 'psychiatry',
  hc: 'hc',
  success: 'success',
  crisisResponseTeam: 'crisis-response-team',
} as const

export type ProviderType = (typeof ProviderTypes)[keyof typeof ProviderTypes]
